import React from 'react';
import { FiMail } from 'react-icons/fi';

export default function Footer() {
  return (
    <footer className="px-4 pb-6 pt-8 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl overflow-hidden rounded-[32px] border border-[var(--line-soft)] bg-[linear-gradient(180deg,rgba(255,255,255,0.96),rgba(237,243,248,0.96))] shadow-[0_24px_60px_-42px_rgba(8,31,53,0.4)]">
        <div className="grid grid-cols-1 gap-8 px-6 py-10 md:grid-cols-3 md:px-8">
          <div>
            <h3 className="mb-2 text-lg font-bold text-[var(--brand-ink)]">
              <span className="text-[var(--brand-accent)]">learnsocialai</span>care.com
            </h3>
            <p className="text-sm leading-relaxed text-[var(--text-muted)]">Professional subscription management and after-sales support you can trust.</p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-[var(--brand-ink)]">Quick Links</h4>
            <ul className="space-y-2 text-sm text-[var(--text-muted)]">
              <li><a href="/" className="transition-colors hover:text-[var(--brand-accent)]">Home</a></li>
              <li><a href="/faqs" className="transition-colors hover:text-[var(--brand-accent)]">FAQs</a></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-[var(--brand-ink)]">Contact</h4>
            <ul className="space-y-2 text-sm text-[var(--text-muted)]">
              <li className="flex items-center gap-2"><FiMail className="h-4 w-4 text-[var(--brand-accent)]" /> support@learnsocialaihub.net</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[var(--line-soft)] px-6 py-4 text-center text-xs text-[var(--text-muted)] md:px-8">
          &copy; 2026 learnsocialaicare.com &mdash; All rights reserved.
        </div>
      </div>
    </footer>
  );
}
